<template>
  <el-form label-width="160px" :inline="true" :model="form" class="demo-form-inline">
    <el-form-item label="标题" required>
      <el-input v-model="form.title" clearable />
    </el-form-item>

    <el-form-item label="拼团分类" prop="class_id">
      <el-select v-model="form.class_id" placeholder="拼团分类" clearable>
        <el-option v-for="item in typesEnum" :label="item.title" :key="item.title" :value="item.id" />
      </el-select>
    </el-form-item>
    <el-form-item label="商品" prop="good_id">
      <el-select v-model="form.good_id" placeholder="商品" clearable>
        <el-option v-for="item in goodsList" :label="item.title" :key="item.title" :value="item.id" />
      </el-select>

    </el-form-item>
    <el-form-item label="图片" prop="img" :rules="[{ required: true, message: '请上传图片' }]">
      <el-upload class="upload-demo" style="width: 114px" :show-file-list="false" drag :headers="headers"
        :action="`${proxy.BASE_API_URL}index/upload`" :on-success="successUpload" :on-error="handleErr"
        :multiple="false">
        <img v-if="form.good_img" :src="proxy.IMG_BASE_URL + form.good_img" width="100%" class="avatar" />
        <el-icon v-else class="avatar-uploader-icon">
          <Plus />
        </el-icon></el-upload>
    </el-form-item>
    <el-form-item label="是否推荐" required>
      <el-select v-model="form.is_recommend" placeholder="是否推荐" clearable>
        <el-option v-for="item in booleanEnums" :label="item.label" :key="item.label" :value="item.value" />
      </el-select>
    </el-form-item>

    <el-form-item label="排序" required>
      <el-input type="number" v-model="form.sort" clearable />
    </el-form-item>
    <el-form-item label="拼团价格" required>
      <el-input v-model="form.price" clearable />
    </el-form-item>
    <el-form-item label="拼团人数" required>
      <el-input v-model="form.people" clearable />
    </el-form-item>
    <!-- <el-form-item label="进度时间" required>
      <el-date-picker
        v-model="form.process_time"
        type="datetime"
        value-format="YYYY-MM-DD HH:mm:ss"
        placeholder="进度时间"
        style="width: 100%"
      />
    </el-form-item> -->
    <el-form-item label="每小时增加人数" required>
      <el-input v-model="form.people_add" clearable />
    </el-form-item>
    <!-- <el-form-item label="进度更新时间" required>
      <el-date-picker
        v-model="form.process_update_time"
        type="datetime"
        value-format="YYYY-MM-DD HH:mm:ss"
        placeholder="进度更新时间"
        style="width: 100%"
      />
    </el-form-item> -->
    <el-form-item label="拼团失败返现" required>
      <el-input v-model="form.fail_money" clearable />
    </el-form-item>
    <el-form-item label="拼团失败返积分" required>
      <el-input v-model="form.fail_points" clearable />
    </el-form-item>
    <el-form-item label="限购次数" required>
      <el-input v-model="form.limit" clearable />
    </el-form-item>
    <el-form-item label="会员等级" required>
      <el-input v-model="form.level" clearable />
    </el-form-item>
    <el-form-item label="需要投资金额" required>
      <el-input v-model="form.item_money" clearable />
    </el-form-item>
    <el-form-item label="显示状态" required>
      <el-select v-model="form.status" placeholder="显示状态" clearable>
        <el-option v-for="item in showStatusEnums" :label="item.label" :key="item.label" :value="item.value" />
      </el-select>
    </el-form-item>
    <el-form-item label="开奖时间" required>
      <el-date-picker v-model="form.next_time" type="datetime" value-format="YYYY-MM-DD HH:mm" placeholder="开奖时间"
        style="width: 100%" />
    </el-form-item>
    <el-form-item label="开奖周期（天）" required>
      <el-input v-model="form.cycle" clearable />
    </el-form-item>
    <el-form-item label="福利说明" required>
      <el-input v-model="form.desc" clearable />
    </el-form-item>

  </el-form>
</template>

<script setup>
import { rolesEnums, booleanEnums, showStatusEnums } from "@/config/enums";
import { htmlDecodeByRegExp } from "@/utils/utils";
import {
  onBeforeUnmount,
  nextTick,
  ref,
  shallowRef,
  onMounted,
  getCurrentInstance,
} from "vue";
import { getTokenAUTH } from "@/utils/auth";

const form = ref({
  title: "",
  class_id: "",
  is_recommend: "",
  sort: "",
  price: "",
  people: "",
  fail_points: "",
  people_add: "",
  good_img:"",
  // process_update_time: "",
  fail_money: "",
  limit: "",
  level: "",
  item_money: "",
  status: "",
  next_time: "",
  cycle: "",
  desc: "",
  good_id: "",
});
const props = defineProps(["item"]);

const headers = ref({});
onMounted(() => {
  headers.value["Accept-Token"] = getTokenAUTH();
  nextTick(() => {
    form.value = Object.assign(form.value, props.item);
  });
  getTYpesEnum();
  getGoodsList()
});

const { proxy } = getCurrentInstance();

const typesEnum = ref([]);

const getTYpesEnum = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/GroupBuy/getGroupBuyClassLists",
  });

  if (res.code == 0) {
    typesEnum.value = res.data.data;
  }
};

const goodsList = ref([]);

const getGoodsList = async () => {
  const res = await proxy.$http({
    method: "get",
    url: "/Goods/getGoodsLists",
    params: {
      page: 1,
      limit: 999,
    },
  });

  if (res.code == 0) {
    goodsList.value = res.data.data;
  }
};

const successUpload = (res) => {
  form.value.good_img = res.data.url;
};

const handleErr = (err) => {
  if (err.status == 320) {
    form.value.good_img = JSON.parse(err.message).data.url;
  }
};

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef();

// 内容 HTML
const valueHtml = ref("<p>hello</p>");
const mode = ref("default");

const toolbarConfig = {};
const editorConfig = {
  placeholder: "请输入内容...",
  MENU_CONF: {
    uploadImage: {
      fieldName: "file",
      maxFileSize: 10 * 1024 * 1024, // 10M
      server: proxy.BASE_API_URL + "index/uploadX",
      headers: {
        "Accept-Token": getTokenAUTH(),
      },
      customInsert(res, insertFn) {
        const url = proxy.IMG_BASE_URL + res.data.url;
        const alt = res.data.alt;
        const href = res.data.href;
        insertFn(url, alt, href);
      },
    },
  },
};

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
});

const handleCreated = (editor) => {
  editorRef.value = editor; // 记录 editor 实例，重要！
};

defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}

.demo-form-inline .el-input {
  --el-input-width: 260px;
}

.demo-form-inline .el-select {
  --el-select-width: 260px;
}

/deep/ .el-radio-group {
  width: 260px;
}

.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}

/deep/ .el-form-item {
  align-items: flex-start;
}
</style>
